import React, { useMemo } from "react";
import { element, number, oneOfType, string } from "prop-types";
import { Accordion, Stack } from "react-bootstrap";
import _ from "lodash";

const Filter = ({ header, counter, body }) => {
  // state

  // variables
  const key = useMemo(() => _.uniqueId(), [_]);

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render

  return (
    <Accordion flush defaultActiveKey={counter === 0 ? [] : [key]}>
      <Accordion.Item eventKey={key}>
        <Accordion.Header className="border-top custom-accordion-header">
          <strong>
            {header} ({counter})
          </strong>
        </Accordion.Header>
        <Accordion.Body>
          <Stack gap={2}>{body}</Stack>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

/* required: display name */
Filter.displayName = "Filter";

/* required: props types */
Filter.propTypes = {
  header: oneOfType([string, element]),
  counter: number,
  body: oneOfType([string, element]),
};

/* required: default props */
Filter.defaultProps = {
  header: "Filter header",
  counter: 0,
  body: "Filter body",
};

export { Filter };
